// A task group's chat (D82): one conversation per group, whose id is the group's.
import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { useParams } from "react-router";

import { groupConversationQuery } from "../chat/api";
import { ChatView } from "../chat/ChatView";
import { useT } from "../i18n";
import { detailCrumbs } from "../layout/nav";
import { taskGroupQuery } from "../tasks/api";
import { PageHeader } from "../ui/PageHeader";
import { ErrorState } from "../ui/states";

interface ChatSlot {
  conversationId: string | undefined;
  emptyBody: string;
  waitHint: string;
  title: string;
}

/** The page around a chat card; the design preview passes a card with a sample conversation. */
export function TaskGroupChat({ card = (props) => <ChatView {...props} /> }: { card?: (props: ChatSlot) => ReactNode }) {
  const { shell, chat } = useT();
  const { groupId = "" } = useParams();
  const group = useQuery(taskGroupQuery(groupId));
  const conversation = useQuery(groupConversationQuery(groupId));
  const page = shell.pages.taskGroupChat;
  const crumbs = detailCrumbs("taskGroups", "/task-groups", { name: group.data?.name ?? "…", href: `/task-groups/${groupId}` }, { name: page.title });
  return (
    <>
      <PageHeader title={group.data ? `${page.title} · ${group.data.name}` : page.title} breadcrumb={crumbs} description={page.subtitle} />
      {conversation.isError ? <ErrorState title={chat.loadFailed} message={conversation.error.message} /> : null}
      {conversation.isError ? null : card({ conversationId: conversation.data?.id, emptyBody: chat.emptyGroup, waitHint: chat.turn.waitsForTurn, title: page.title })}
    </>
  );
}

export default function TaskGroupChatPage() {
  return <TaskGroupChat />;
}
